<template>
  <div class="main-layout">

    <!-- <div class="layout-tab" v-if="!loading">
      <u-tab v-model="menu" :items="menuItems" @click="eventClick"></u-tab>
    </div> -->
    <!-- <v-progress-linear indeterminate color="primary" v-else></v-progress-linear> -->
    <div class="layout-content">
      <u-tab-items v-model="storeGetCurrentOption.name">
        <!-- // # Tab Hospital Users -->
        <template v-slot:menuUsers>
          <menuUsers
            ref="menuUsers"
            :userInfo="userInfo"
            :hospital_id="hospital_id"
          />
        </template>
        <template v-slot:menuAPI>
          <menuApis
            ref="menuAPI"
            :userInfo="userInfo"
            :hospital_id="hospital_id"
          >
          </menuApis>
        </template>
        <!-- // # Tab Hospital Feature  -->
        <template v-slot:menuMenu>
          <menuMenu
            ref="menuMenu"
            :hospital_id="hospital_id"
            :menuSystem="menuSystem"
            :priorityUser="priorityUser"
            @changeMenu="init()"
          />
        </template>

        <!-- // # Tab Hospital Permission  -->
        <template v-slot:menuPermission>
          <menuPermission ref="menuPermission" :hospital_id="hospital_id" />
        </template>

        <!-- // # Tab Hospital User Approve -->
        <template v-slot:menuUsersApprove>
          <menuUsersApprove ref="menuUsersApprove" :hospital_id="hospital_id" />
        </template>

        <!-- // # Tab Hospital Package -->
        <template v-slot:menuPackage>
          <menuPackage
            ref="menuPackage"
            :hospital_id="hospital_id"
            :priorityUser="priorityUser"
          />
        </template>

        <!-- // # Tab Hospita History  -->
        <template v-slot:menuHistory>

          <menuHistory
            ref="menuHistory"
            :hospital_id="hospital_id"
            :priorityUser="priorityUser"
            :userInfo="userInfo"
          />
        </template>

        <!-- hospital -->
        <template v-slot:menuUpload>
          <menuUpload
            ref="menuUpload"
            :hospital_id="hospital_id"
            @toHistory="menu = 'menuHistory'"
          />
        </template>

        <!-- // # Tab Hospital Dashboard -->
        <template v-slot:menuDashboard>
          <menuDashboard :hospital_id="hospital_id" ref="menuDashboard" />
        </template>

        <!-- # Tab Project Dashboard -->
        <template v-slot:customDashbord>
          <v-tab-item
            v-for="Dashbord in itemsDashbord"
            :key="Dashbord.name"
            :value="Dashbord.name"
          >
            <!-- //TODO IFRAME -->
            <!-- {{Dashbord}} -->
            <iframeDashbord
              v-if="Dashbord.type == 'iframe'"
              :url="Dashbord.url"
            />
            <!-- <iframeDashbord
              v-if="Dashbord.type == 'iframe'"
              src="https://www.figma.com/proto/yF7B3hFYCDy4Jt5tmFroFL/%5BConfirm%5D-CXR?node-id=1046-2843&starting-point-node-id=1046%3A2843"
            /> -->

            <!-- //TODO WIDGET -->
            <!-- <Widget
              v-if="Dashbord.type == 'datasource'"
              :menu-id="Dashbord.menu_id"
              :project-id="project_id"
            ></Widget> -->
          </v-tab-item>
        </template>
      </u-tab-items>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

import menuDashboard from '@/components/Hospital/Dashboard.vue'
import menuPackage from '@/components/Hospital/Package.vue'
import menuUsers from '@/components/Hospital/Users.vue'
import menuUsersApprove from '@/components/Hospital/UsersApprove.vue'
import menuPermission from '@/components/Hospital/Permission.vue'
import menuMenu from '@/components/Hospital/MenuHospital.vue'
import menuHistory from '@/components/Hospital/History.vue'
import menuUpload from '@/components/Hospital/Upload.vue'
import menuApis from '@/components/Hospital/Apis.vue'
// import iframeDashbord from '../DashboardByIframe.vue'
import iframeDashbord from '@/components/Hospital/DashboardByIframe.vue'
// import iframeDashbord from '@/components/Hospital/DashboardByIframe.vue'

export default {
  components: {
    menuDashboard,
    menuPackage,
    menuUsers,
    menuUsersApprove,
    menuPermission,
    menuMenu,
    menuHistory,
    menuUpload,
    menuApis,
    iframeDashbord
  },

  computed: {
    ...mapGetters(['storeGetCurrentOption'])
  },
  data () {
    return {
      userInfo: null,
      priorityUser: 99, // NOTE เมื่อ User มีการ Access เข้ามาให้ Priority เป็น 99
      loading: false,
      hospital_id: '',
      menu: '',
      menuItems: [],
      menuSystem: [
        {
          text: 'ภาพรวม',
          name: 'menuDashboard',
          description: 'ดูภาพรวม',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'แพ็คเกจ',
          name: 'menuPackage',
          description: 'จัดการแพ็คเกจ',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'บัญชีผู้ใช้',
          name: 'menuUsers',
          description: 'จัดการบัญชีผู้ใช้',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'รออนุมัติ',
          name: 'menuUsersApprove',
          description: 'คลิกเพื่อดูคำขอที่รออนุมัติ',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'สิทธิ',
          name: 'menuPermission',
          description: 'จัดการสิทธิ',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'เมนู',
          name: 'menuMenu',
          description: 'จัดการเมนู',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'ประวัติ',
          name: 'menuHistory',
          description: 'จัดการประวัติ',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'อัปโหลด',
          name: 'menuUpload',
          description: 'จัดการอัปโหลด',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'API',
          name: 'menuAPI',
          description: 'จัดการ API key',
          is_iframe: false,
          type: 'none',
          url: ''
        },
        {
          text: 'Iframe',
          name: 'menuIframe',
          description: '',
          is_iframe: true,
          type: 'iframe',
          url: ''
        }
      ],
      itemsDashbord: []
    }
  },
  async created () {
    this.hospital_id = this.$route.params.hospital_id
    await this.initHospitalInfo()
    await this.initUserInfo()
    await this.init()
  },
  methods: {
    ...mapMutations(['storeSetProjectMenus', 'storeSetCurrentOption']),
    // async initUserInfo () {
    //   this.loading = true
    //   const res = await this.getUserInfo()
    //   this.loading = false
    //   if (res.status) {
    //     this.userInfo = res.data
    //     const ps = []
    //     for (let index = 0; index < this.userInfo.permissions.length; index++) {
    //       ps.push(this.userInfo.permissions[index].priority)
    //     }

    //     this.priorityUser = Math.min.apply(Math, ps)
    //   } else {
    //     this.antmessage.error(res.message)
    //   }
    // },
    async initUserInfo () {
      this.loading = true
      try {
        const res = await this.getUserInfo()
        this.loading = false
        if (res.status) {
          this.userInfo = res.data
          const priorities = this.userInfo.permissions.map(permission => permission.priority)
          this.priorityUser = Math.min(...priorities)
        } else {
          this.antmessage.error(res.message)
        }
      } catch (error) {
        this.loading = false
        this.antmessage.error('Failed to fetch user information')
        console.error(error)
      }
    },
    async initHospitalInfo (hospitalId) {
      this.loading = true
      const paylod = {
        hospital_id: this.hospital_id
      }
      const res = await this.getHospitalInfo(paylod)
      this.loading = false
      if (res.status) {
        this.$store.commit('hospitalName', res.data.name)
      } else {
        this.antmessage.error(res.message)
      }
    },
    // async setURL () {
    //   // TODO เป็น function สำหรับ Replace string จาก URL
    //   // TODO โดยจะทำการ ใส่ค่าไปใน URL
    //   for (let index = 0; index < this.itemsDashbord.length; index++) {
    //     this.itemsDashbord[index].url = await this.checkCaseReplace(
    //       this.itemsDashbord[index].url
    //     )
    //   }
    // },
    async init () {
      // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
      this.loading = true
      const payload = {
        user_id: this.userInfo.user_id,
        hospital_id: this.hospital_id
      }
      const res = await this.getHospitalMenuFromUser(payload)
      this.loading = false
      if (res.status) {
        this.menuItems = res.data

        // FIX เป็นการลบ Menu Upload ออกไปจาก Menu โดยต้องไปแก้ที่ Frontend ด้วย 2024-06-06 UKRIT
        this.menuItems = this.menuItems.filter((e) => e.text !== 'อัปโหลด')

        // TODO ทำการส่งค่าไปยัง Store ------- 2024-04-12
        this.storeSetProjectMenus(JSON.parse(JSON.stringify(this.menuItems)))
        this.storeSetCurrentOption(
          JSON.parse(JSON.stringify(this.menuItems[0]))
        ) // NOTE เก็บค่า Active
        // TODO ---------------------------

        const menuIframe = this.menuItems.filter(
          // (val) => val.type === 'iframe' && val.type === 'datasource'
          (val) =>
            val.type !== 'none' && val.type !== '' && val.type !== 'alert'
        )
        // TODO Set menu ที่เป็น iframe ลงใน itemsDashbord
        this.itemsDashbord = menuIframe
        // this.setURL()
      } else {
        this.antmessage.error(res.message)
      }
    },
    eventClick (e) {
      // e.name --> name component same ref
      if (this.$refs[e.name]) {
        this.$refs[e.name].init()
      }
    }
  }
}
</script>

<style lang="css" scoped>
/* // TODO สำหรับจัดการหน้าเพจทั้งหมด */
.main-layout {
  height: 100%;
  /* background: blue; */
}

/* // TODO สำหรับจัดการ Tab ของ Page */
.layout-tab {
  height: 48px;
  overflow: hidden;
}

/* // TODO สำหรับจัดการ Content ของเพจ */
.layout-content {
  height: calc(100%);
  /* height: 100%; */
  padding: 0;
  margin: 0;
}
.header-custom-table .header-custom-search {
  display: flex;
  gap: 1rem;

  /* background: gray; */
  justify-content: flex-end;
  align-items: center;
  height: 100%;
}

.header-custom-table .header-custom-actions {
  display: flex;
  gap: 1rem;
  /* background: gray; */
  align-items: center;
  height: 100%;
  min-height: 70px;

  /* justify-content: flex-end; */
}
</style>
